var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDexter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3075 62.8025C14.3075 72.5736 25.3243 77.4455 25.3243 77.4455H25.3514C21.6283 75.8929 21.7232 70.4399 25.6461 69.098L43.3874 63.0233C52.4123 59.9316 59.4993 52.8241 62.5787 43.7767L68.6359 25.9842C70.0079 21.9515 75.6959 21.9515 77.0713 25.9842L83.1285 43.7767C86.2113 52.8275 93.2983 59.935 102.32 63.0233L120.061 69.098C120.505 69.2508 120.898 69.4581 121.247 69.7061C124.089 71.2859 131.081 75.954 131.081 83.741C131.081 93.5121 126.477 98.6966 109.441 104.53L127.182 98.4554C137.901 94.7827 145.103 84.6855 145.103 73.3278C145.103 61.9701 137.901 51.8695 127.182 48.2002L109.441 42.1256C106.886 41.2524 104.844 39.2003 103.97 36.6387L97.9124 18.8496C94.2503 8.09665 84.182 0.873657 72.857 0.873657C61.5319 0.873657 51.4603 8.09665 47.8016 18.8462L41.7444 36.6387C40.8738 39.2003 38.8276 41.249 36.2733 42.1256L29.5284 44.4358C17.7257 49.3859 14.3075 54.3972 14.3075 62.8059V62.8025Z",
    fill: "url(#paint0_linear_262_8760)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.892 83.9483C130.892 74.1772 119.875 69.3052 119.875 69.3052H119.848C123.571 70.8579 123.476 76.3108 119.553 77.6528L101.812 83.7274C92.7867 86.8191 85.6997 93.9266 82.6203 102.974L76.5631 120.766C75.1911 124.799 69.5031 124.799 68.1277 120.766L62.0705 102.974C58.9877 93.9232 51.9007 86.8157 42.8793 83.7274L25.1379 77.6528C24.6941 77.4999 24.3012 77.2926 23.9522 77.0446C21.11 75.4648 14.1178 70.7967 14.1178 63.0097C14.1178 53.2387 18.7216 48.0541 35.7583 42.2207L18.017 48.2954C7.30172 51.9646 0.0994873 62.0652 0.0994873 73.4229C0.0994873 84.7806 7.30172 94.8813 18.0204 98.5505L35.7617 104.625C38.316 105.498 40.3588 107.55 41.2328 110.112L47.29 127.901C50.9487 138.651 61.0204 145.874 72.3454 145.874C83.6705 145.874 93.7421 138.651 97.4008 127.901L103.458 110.109C104.329 107.547 106.375 105.498 108.929 104.622L115.674 102.312C127.477 97.3614 130.895 92.3502 130.895 83.9415L130.892 83.9483Z",
    fill: "url(#paint1_linear_262_8760)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_262_8760",
    x1: 144.432,
    y1: 91.5212,
    x2: 30.5512,
    y2: 27.0098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_262_8760",
    x1: 0.770251,
    y1: 55.2228,
    x2: 114.648,
    y2: 119.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDexter);
export default __webpack_public_path__ + "static/media/logo-dexter.97aee19b99d6e1bbe6579d283474d1bd.svg";
export { ForwardRef as ReactComponent };